import { useState, useCallback } from 'react';

export const useTagEditModal = () => {
    const [editTagId, setEditTagId] = useState<number | null>(null);

    const addTag = useCallback(() => {
        setEditTagId(-1);
    }, []);

    const editTag = useCallback((tagId: number) => {
        setEditTagId(tagId);
    }, []);

    const closeTagModal = useCallback(() => {
        setEditTagId(null);
    }, []);

    return {
        editTagId,
        addTag,
        editTag,
        closeTagModal,
    };
};
